import { useSettingsStore } from '@/store';
import { Logo } from './Logo';

function AuthSectionImage() {
  const { settings } = useSettingsStore();

  const coverImage = settings?.ui?.theming?.coverImage;

  const textColor = settings?.ui?.theming?.coverImageTextColor;

  const containerStyle = {
    backgroundImage: `url(${coverImage || null})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    color: textColor || null,
  };

  return (
    <div
      className={` flex flex-col items-center justify-between  gap-7   ${!coverImage ? 'my-bg text-secondary-foreground' : ''}`}
      style={coverImage ? containerStyle : null}
    >
      <div className="relative flex flex-col h-full w-full max-w-4xl pt-10 md:pt-20 lg:pt-32 items-center justify-center gap-1 lg:gap-2 text-center flex-grow">
        <Logo className="absolute top-5 left-5 sm:left-10 w-10 sm:w-16 md:w-20 lg:w-[120px] h-10 sm:h-16 md:h-20 lg:h-24" />
        <h2 className="text-lg sm:text-xl md:text-3xl lg:text-4xl font-extrabold capitalize">
          Twin Tv
        </h2>
        <p className="text-sm sm:text-base md:text-lg w-full sm:w-1/2 lg:w-2/3 m-auto ">
        Welcome to Twin TV – where two minds connect, share thoughts, and explore insights together. Start your conversation and experience the power of twin synergy!
        </p>
      </div>

      <div className="w-full flex justify-center mt-auto ">
        <img
          src={'/images/loginImage.svg'}
          alt="Login Illustration"
          className="w-full max-w-xs sm:max-w-sm md:max-w-md lg:max-w-[600px] object-cover"
        />
      </div>
    </div>
  );
}

export default AuthSectionImage;
